export const BACKEND_URL: string = 'https://zetreex.linuxtech.io:8001';
